import React from 'react'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Routes,
  useSearchParams
} from 'react-router-dom'

import { AppRoutesWrapper } from 'components/AppRoutesWrapper'
import { AuthenticatedRoutes } from 'components/AuthenticatedRoutes'
import { AuthenticatedRoutesWrapper } from 'components/AuthenticatedRoutesWrapper'
import { UnauthenticatedRoutes } from 'components/UnauthenticatedRoutes'
import { UnauthenticatedRoutesWrapper } from 'components/UnauthenticatedRoutesWrapper'
import useAuth from 'hooks/use-auth'

const AppRoutes: React.FC = () => {
  const { session, setActiveTeamId } = useAuth()
  const [searchParams] = useSearchParams()
  const hasSession = Boolean(session.company_id)

  if (searchParams.has('teamId')) {
    const teamQueryParam: string = searchParams.get('teamId')
    // If we have no teams yet (as we're still fetching the session), we set to the active team to the query param
    // if the session comes back without that team, then the session will swap to a valid team
    // If we do have teams for the session, we only set the activeTeamId if the team exists in the session
    if (
      !session?.teams ||
      Boolean(session.teams.find((team) => team.identifier === teamQueryParam))
    ) {
      setActiveTeamId(teamQueryParam)
    }
  }

  return (
    <Routes>
      {hasSession ? (
        <Route element={<AuthenticatedRoutesWrapper />}>
          <Route element={<AuthenticatedRoutes />} path="/*" />
        </Route>
      ) : (
        <Route element={<UnauthenticatedRoutesWrapper />}>
          <Route element={<UnauthenticatedRoutes />} path="/*" />
        </Route>
      )}
    </Routes>
  )
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AppRoutesWrapper />}>
      <Route element={<AppRoutes />} path={'/*'} />
    </Route>
  )
)

const App: React.FC = () => <RouterProvider router={router} />

export default App
